import NotificationSection from "../components/NotificationSection";

const NotificationHomePage = () => {
  return (
    <section className="min-h-full bg-[#F3F4F8] md:p-6">
      <div className="rounded-[16px] bg-white p-4 md:p-6">
        <NotificationSection />
      </div>
    </section>
  );
};

export default NotificationHomePage;
